const MAX_INLINE_IMAGES = 10;
const INLINE_UPLOAD_MAX_BYTES = 50 * 1024 * 1024;
const MISSING_SCREENSHOT_PLACEHOLDER = '[missing screenshot]';

function insertAtCursor(text, start, end, insertion) {
  const src = String(text || '');
  const insert = String(insertion || '');
  let s = Number(start);
  let e = Number(end);
  if (!Number.isFinite(s)) s = src.length;
  if (!Number.isFinite(e)) e = s;
  s = Math.max(0, Math.min(s, src.length));
  e = Math.max(s, Math.min(e, src.length));
  return {
    text: src.slice(0, s) + insert + src.slice(e),
    cursor: s + insert.length,
  };
}

function referencedCids(body) {
  const src = String(body || '');
  const seen = new Set();
  const out = [];
  const re = /cid:paste-(\d+)/g;
  let match;
  while ((match = re.exec(src))) {
    const cid = `paste-${match[1]}`;
    if (!seen.has(cid)) {
      seen.add(cid);
      out.push(cid);
    }
  }
  return out;
}

function nextInlineIdFromCids(cids) {
  let max = 0;
  for (const cid of cids || []) {
    const n = Number(String(cid).replace(/^paste-/, ''));
    if (Number.isFinite(n) && n > max) max = n;
  }
  return max + 1;
}

function rewriteCidImages(
  html,
  urlMap,
  placeholder = MISSING_SCREENSHOT_PLACEHOLDER,
) {
  return String(html || '').replace(
    /<img\b([^>]*?)\bsrc=(["'])cid:([^"']+)\2([^>]*)>/gi,
    (full, pre, quote, cid, post) => {
      const url = urlMap && urlMap[cid];
      if (url) {
        return `<img${pre}src=${quote}${url}${quote}${post}>`;
      }
      return placeholder;
    },
  );
}

function pruneInlineImages(images, body) {
  const needed = new Set(referencedCids(body));
  return (images || []).filter((img) => img && needed.has(img.cid));
}

function missingReferencedCids(body, images) {
  const have = new Set((images || []).map((img) => img && img.cid));
  return referencedCids(body).filter((cid) => !have.has(cid));
}

function firstClipboardImageItem(items) {
  if (!items || typeof items.length !== 'number') return null;
  for (let i = 0; i < items.length; i += 1) {
    const item = items[i];
    if (item && String(item.type || '').startsWith('image/')) {
      return item;
    }
  }
  return null;
}

function markdownMarker(cid) {
  return `![screenshot](cid:${cid})`;
}

function canAddInlineImage(count) {
  return Number(count) < MAX_INLINE_IMAGES;
}

function fileKeyForCid(fileKeyOrMap, cid) {
  if (!fileKeyOrMap) return '';
  if (typeof fileKeyOrMap === 'string') return fileKeyOrMap;
  return String(fileKeyOrMap[cid] || '');
}

function sentInlineImageSrc(emailId, cid, fileKey) {
  const url = `/api/sent-email-inline/${emailId}/${encodeURIComponent(cid)}`;
  if (!fileKey) return url;
  return `${url}?fileKey=${encodeURIComponent(fileKey)}`;
}

function rewriteLoggedCidImages(html, emailId, fileKeyOrMap) {
  if (!emailId) return String(html || '');
  return String(html || '').replace(
    /(<img\b[^>]*?\bsrc=)(["'])cid:([^"']+)\2/gi,
    (full, pre, quote, cid) => {
      const key = fileKeyForCid(fileKeyOrMap, cid);
      if (!key) return full;
      return `${pre}${quote}${sentInlineImageSrc(emailId, cid, key)}${quote}`;
    },
  );
}

function cidObjectUrlMap(images) {
  const map = {};
  for (const img of images || []) {
    if (img && img.cid && img.objectUrl) {
      map[img.cid] = img.objectUrl;
    }
  }
  return map;
}

module.exports = {
  MAX_INLINE_IMAGES,
  INLINE_UPLOAD_MAX_BYTES,
  MISSING_SCREENSHOT_PLACEHOLDER,
  insertAtCursor,
  referencedCids,
  nextInlineIdFromCids,
  rewriteCidImages,
  rewriteLoggedCidImages,
  pruneInlineImages,
  missingReferencedCids,
  firstClipboardImageItem,
  markdownMarker,
  canAddInlineImage,
  cidObjectUrlMap,
};
